<template>
  <div class="Campaign">
    <div class="no-content" v-if="!campaign">
      <h2>Loading...</h2>
    </div>
    <div class="content" v-else>
      <div :style="{ 'background-color': campaign.pageData.bgBanner }">
        <v-img :src="campaign.pageData.bannerUrl" max-width="1200" class="mx-auto"></v-img>
      </div>
      <v-container>
        <v-row id="campaign" class="text-center my-0">
          <v-col cols="12">
            <h2 class="text-h4 primary--text text--darken-3 font-weight-light font-italic py-8">
              CAMPANHA
            </h2>
            <div class="text-left px-4">
              <div class="subtitle-1">
                <span>Cliente</span>:
                <span class="font-weight-bold text-uppercase">{{ campaign.client }}</span>
              </div>
              <div class="subtitle-1">
                <span>Campanha</span>:
                <span class="font-weight-bold text-uppercase">{{ campaign.name }}</span>
              </div>
              <div class="subtitle-1">
                <span>Produto</span>:
                <span class="font-weight-bold text-uppercase">{{ campaign.product }}</span>
              </div>
              <div class="subtitle-1">
                <span>Peça</span>:
                <span class="font-weight-bold text-uppercase">
                  {{ campaign.type }} {{ campaign.format }}
                </span>
              </div>
              <div class="subtitle-1">
                <span>Veiculação</span>:
                <span class="font-weight-bold text-uppercase">{{ campaign.timeFrame }}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-container>
        <v-row id="radios" class="text-center my-0">
          <v-col cols="12">
            <h2 class="text-h4 primary--text text--darken-3 font-weight-light font-italic py-8">
              RÁDIOS SELECIONADAS
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div>
              <v-simple-table
                v-if="campaign.id == 'programa-de-testagem-covid-19'"
                dense
                height="100%"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="primary darken-2 text-left white--text">ID. SECOM</th>
                      <th class="primary darken-2 text-left white--text">MUNICÍPIO</th>
                      <th class="primary darken-2 text-left white--text">UF</th>
                      <th class="primary darken-2 text-left white--text">RÁDIO</th>
                      <th class="primary darken-2 text-left white--text">FX</th>
                      <th class="primary darken-2 text-left white--text">PRX</th>
                      <th class="primary darken-2 text-left white--text">PROGRAMA</th>
                      <th class="primary darken-2 text-left white--text">APRESENTADOR</th>
                      <th class="primary darken-2 text-left white--text">INÍCIO</th>
                      <th class="primary darken-2 text-left white--text">FIM</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(radio, i) in campaign.radiosData"
                      :key="i"
                      :class="{ grey: isOdd(i), 'lighten-5': isOdd(i) }"
                    >
                      <td class="text-left">{{ radio.idSecom }}</td>
                      <td class="text-left">{{ radio.municipio }}</td>
                      <td class="text-left">{{ radio.uf }}</td>
                      <td class="text-left">{{ radio.name }}</td>
                      <td class="text-left">{{ radio.fx }}</td>
                      <td class="text-left">{{ radio.prx }}</td>
                      <td class="text-left">{{ radio.programa }}</td>
                      <td class="text-left">{{ radio.apresentador }}</td>
                      <td class="text-left">{{ radio.inicio }}</td>
                      <td class="text-left">{{ radio.fim }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-simple-table
                v-else
                fixed-header
                :dense="isMobile ? true : false"
                :height="
                  isMobile
                    ? campaign.radiosData.length > 10
                      ? 674
                      : '100%'
                    : campaign.radiosData.length > 10
                    ? 530
                    : '100%'
                "
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="primary darken-2 text-left white--text">ID. SECOM</th>
                      <th class="primary darken-2 text-left white--text">MUNICÍPIO</th>
                      <th class="primary darken-2 text-left white--text">UF</th>
                      <th class="primary darken-2 text-left white--text">RÁDIO</th>
                      <th class="primary darken-2 text-left white--text">FX</th>
                      <th class="primary darken-2 text-left white--text">PRX</th>
                      <th class="primary darken-2 text-left white--text">PROGRAMA</th>
                      <th class="primary darken-2 text-left white--text">APRESENTADOR</th>
                      <th class="primary darken-2 text-left white--text">INÍCIO</th>
                      <th class="primary darken-2 text-left white--text">FIM</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(radio, i) in campaign.radiosData"
                      :key="i"
                      :class="{ grey: isOdd(i), 'lighten-5': isOdd(i) }"
                    >
                      <td class="text-left">{{ radio.idSecom }}</td>
                      <td class="text-left">{{ radio.municipio }}</td>
                      <td class="text-left">{{ radio.uf }}</td>
                      <td class="text-left">{{ radio.name }}</td>
                      <td class="text-left">{{ radio.fx }}</td>
                      <td class="text-left">{{ radio.prx }}</td>
                      <td class="text-left">{{ radio.programa }}</td>
                      <td class="text-left">{{ radio.apresentador }}</td>
                      <td class="text-left">{{ radio.inicio }}</td>
                      <td class="text-left">{{ radio.fim }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-if="campaign">
        <v-row id="content" class="text-center my-0">
          <v-col cols="12">
            <h2 class="text-h4 primary--text text--darken-3 font-weight-light font-italic py-8">
              CONTEÚDO DIVULGADO
            </h2>
            <div class="text-left px-4">
              <p class="font-weight-bold">
                <span>{{ campaign.client }}</span> <br />
                <span>
                  {{ campaign.name }}
                </span>
                <br />
                <span>{{ campaign.type }} {{ campaign.format }}</span> <br />
              </p>

              <div v-if="campaign.id == 'campanha-nacional-cuida-mais-brasil'">
                <p><b> PEÇA 01: CUIDA MAIS BRASIL</b></p>

                <div style="margin-left: 20px">
                  <p>
                    É, minha gente… Vocês sabem… A gente sempre sonha com o melhor pros nossos
                    filhos, né? Com eles crescendo fortes e com saúde!
                  </p>
                  <p>
                    É por isso que, como pai, eu fico muito feliz em contar pra todas as famílias
                    que, agora, com o Cuida Mais Brasil, mais crianças e mulheres vão poder ter
                    acesso a atendimento de qualidade com pediatras e ginecologistas-obstetras na
                    <i>Atenção Primaria à Saúde</i> em todo o país.
                  </p>
                  <p>
                    É mais cuidado desde o início da vida. Isso mesmo, na Unidade Básica de Saúde
                    aqui pertinho e na mais perto daí, de onde você mora também. O Cuida Mais Brasil
                    já começou a levar mais atenção e cuidado pro Brasil inteiro.
                  </p>
                  <p>É isso.... Cuida Mais Brasil. Cuidar para crescer e viver melhor.</p>
                </div>

                <p style="margin-top: 40px">
                  <b>PEÇA 02:CUIDA MAIS BRASIL (TESTEMUNHAL COMUNICADOR 2)</b>
                </p>

                <div style="margin-left: 20px">
                  <p>
                    É, minha gente… Vocês sabem… Quem é pai ou mãe sempre sonha com o melhor pros
                    filhos, né? Com eles crescendo fortes e com saúde!
                  </p>
                  <p>
                    É por isso que eu fico muito feliz em contar pra todas as famílias que, agora,
                    com o Cuida Mais Brasil, mais crianças e mulheres vão poder ter acesso a
                    atendimento de qualidade com pediatras e ginecologistas-obstetras na
                    <i>Atenção Primária à Saúde</i> em todo o país.
                  </p>
                  <p>
                    É mais cuidado desde o início da vida. Isso mesmo, na Unidade Básica de Saúde
                    aqui pertinho e na mais perto daí, de onde você mora também. O Cuida Mais Brasil
                    já começou a levar mais atenção e cuidado pro Brasil inteiro.
                  </p>
                  <p>É isso... Cuida Mais Brasil. Cuidar para crescer e viver melhor.</p>
                </div>
              </div>

              <div v-if="campaign.id == 'programa-de-testagem-covid-19'">
                <p>
                  BG: Mapa do Brasil apontando diversos municípios com postos de testagem, logos e
                  lettering "PLANO NACIONAL DE EXPANSÃO DA TESTAGEM PARA O NOVO CORONAVÍRUS".
                </p>
                <p>
                  <span>LOC. APRESENTADOR(A)</span><br />
                  Já são milhões de brasileiros vacinados contra a Covid-19. E para seguir com mais
                  segurança, o Governo Federal intensifica o Plano Nacional de Expansão da Testagem
                  para o Novo Coronavírus com testes rápidos. Em todo o Brasil, será reforçada a
                  testagem nas unidades de saúde e nos locais com grande circulação de pessoas
                  também, para reduzir a transmissão do vírus no país.
                </p>
                <p>
                  O teste não dói, não incomoda, é gratuito e em apenas 15 minutos você já tem o
                  resultado! Com a testagem em massa, o Ministério da Saúde pode monitorar melhor o
                  índice de contágio e as novas variantes, além das pessoas que estão contaminadas,
                  mesmo as que não tiverem sintomas.
                </p>
                <p>
                  E quanto mais pessoas testadas, mais cuidamos uns dos outros e podemos circular
                  com mais segurança. Faça o teste nos postos de saúde, UPAs ou postos de testagem
                  da sua cidade, beleza?
                </p>
                <p>Plano Nacional de Expansão da Testagem. Vamos testar. E seguir com segurança.</p>
              </div>

              <div
                v-if="
                  campaign.id == 'campanha-nacional-de-multivacinacao-para-criancas-e-adolescentes'
                "
              >
                <p class="font-weight-bold">
                  <span>PEÇA: B - TESTEMUNHAL DIA D 15/10/21</span> <br />
                  <span>MULTIVACINAÇÃO</span>
                  <br />
                  <span>Textos Merchan</span>
                </p>
                <p>DIA D</p>
                <p>
                  <span>Texto base 60"</span><br />
                  Atenção, papais, mamães e responsáveis. Chegou a hora da gente falar sobre
                  vacinação. Gente, neste sábado, dia 16 de outubro, é dia de atualizar a caderneta
                  de vacinação dos seus filhos. É isso mesmo, dia de levar as crianças e
                  adolescentes menores de 15 anos de idade ao posto de vacinação mais perto de você
                  para atualizar a caderneta com as vacinas que estão faltando. São 18 vacinas
                  disponíveis para proteger seus filhos e sua família de doenças como poliomielite,
                  sarampo, rubéola, caxumba, entre muitas outras.
                </p>
                <p>
                  No site gov.br/saude você encontra todas as vacinas disponíveis para a proteção
                  das crianças e adolescentes, dê uma olhada! Não se esqueça! É neste sábado, dia 16
                  de outubro, e tem que levar a caderneta de vacinação, viu?
                </p>
                <p>
                  Quando protegemos nossas crianças, protegemos o país inteiro. Entre nesse
                  movimento. É o...Movimento Vacina Brasil! É mais proteção para todos!
                </p>
                <div class="text-left px-4 mt-12">
                  <p class="font-weight-bold">
                    <span>PEÇA: C - TESTEMUNHAL PERIODO 22 A 26/10/21</span>
                    <br />
                    <span>MULTIVACINAÇÃO</span>
                    <br />
                    <span>Textos Merchan</span>
                  </p>
                  <p>PERÍODO</p>
                  <p>
                    <span>Texto base 60"</span><br />
                    Pessoal, vamos falar da Campanha de Multivacinação? Esse é um recado para todos
                    os pais, mães e responsáveis: tá na hora de atualizar a caderneta de vacinação
                    para crianças e adolescentes menores de 15 anos de idade. É isso aí, de 1º a 29
                    de outubro leve seus filhos ao posto de vacinação mais perto de você para
                    atualizar a caderneta com as vacinas que estão faltando. São 18 vacinas
                    disponíveis para proteger seus filhos e sua família de doenças como
                    poliomielite, sarampo, rubéola, caxumba, entre muitas outras. São doenças muito
                    perigosas que podem prejudicar o futuro dos seus pequenos!
                  </p>
                  <p>
                    Saiba mais no site gov.br/saude onde você encontra todas as vacinas disponíveis
                    nessa campanha, dê uma olhada! Vamos vacinar e proteger nossas crianças e
                    adolescentes? Não se esqueça de levar a caderneta, viu? Faça parte desse
                    movimento! É o...Movimento Vacina Brasil. É mais proteção para todos!
                  </p>
                </div>
                <div class="text-left px-4 mt-12">
                  <p class="font-weight-bold">
                    <span>PEÇA: D - TESTEMUNHAL ULTIMOS 27 A 29/10/21 </span>
                    <br />
                    <span>MULTIVACINAÇÃO</span>
                    <br />
                    <span>Textos Merchan</span>
                  </p>
                  <p>ÚLTIMOS DIAS</p>
                  <p>
                    <span>Texto base 60"</span><br />
                    Agora é o momento de falar de saúde e da proteção das crianças e adolescentes.
                    Pais, mães e responsáveis, o período de atualizar a caderneta de vacinação dos
                    seus filhos está chegando ao fim! Até 29 de outubro você pode levar as crianças
                    e adolescentes menores de 15 anos de idade ao posto de vacinação mais perto de
                    você para atualizar a caderneta com as vacinas que estão faltando. São 18
                    vacinas disponíveis para proteger seus filhos e sua família de doenças como
                    poliomielite, sarampo, rubéola, caxumba, entre muitas outras. São doenças muito
                    perigosas que podem prejudicar o futuro dos seus pequenos!
                  </p>
                  <p>
                    Saiba mais no site gov.br/saude onde você encontra todas as vacinas disponíveis
                    nessa campanha, dê uma olhada! Vamos vacinar e proteger nossas crianças e
                    adolescentes? Não se esqueça de levar a caderneta, viu? Faça parte desse
                    movimento! É o...Movimento Vacina Brasil. É mais proteção para todos!
                  </p>
                  <p>
                    No site gov.br/saude você encontra todas as vacinas disponíveis nessa campanha,
                    dê uma olhada! Vamos vacinar e proteger nossas crianças e adolescentes? São os
                    últimos dias, hein? Não se esqueça de levar a caderneta, combinado?
                  </p>
                  <p>Movimento Vacina Brasil. É mais proteção para todos!</p>
                </div>
              </div>

              <div v-if="campaign.id === '30-anos-sest-senat'">
                <p><b> Peça: </b>Manifesto Movimento</p>
                <p>
                  A jornada de parceria do Sest Senat com os serviços de transporte do Brasil
                  começou há 30 anos.
                </p>
                <p>
                  Uma parceria que movimenta a vida dos trabalhadores do transporte. Por terra,
                  trilhos, água e ar, o Sest Senat construiu caminhos para oferecer mais qualidade
                  de vida para muita gente. Percorrendo novas rotas para levar mais conhecimento.
                </p>
                <p>
                  Voando alto para criar mais oportunidades. Tornando-se um porto seguro para quem
                  está saindo ou chegando. Sempre transportando o bem-estar para colocar nos trilhos
                  a saúde dos brasileiros.
                </p>
                <p>
                  Somos o Sest Senat, parceiro dos transportes do Brasil e há 30 anos movimentando a
                  vida de quem move o país.
                </p>
                <p>
                  <b>SEST SENAT. Presente. Perto de você.</b>
                </p>
              </div>

              <div v-if="campaign.id === 'infraero-50-anos'">
                <p>
                  <b>
                    Locutor, com bom humor, brinca de imitar a voz característica dos aeroportos:
                  </b>
                </p>
                <p style="margin-left: 20px">
                  - Atenção, passageiros com destino ao futuro: embarque imediato com a Infraero.
                </p>
                <p>
                  <b> Locutor volta a falar naturalmente, conversando com os ouvintes: </b>
                </p>
                <p style="margin-left: 20px">
                  - Pessoal, hoje eu quero falar da Infraero. É uma grande empresa brasileira,
                  reconhecida no mundo todo. Foi ela que implantou e administrou os principais
                  aeroportos do Brasil! E, agora, está se dedicando a desenvolver aeroportos
                  regionais por todo o país. Sim! A Infraero vai promover a aviação regional!
                </p>
                <p style="margin-left: 20px">
                  - E vocês têm ideia do que a chegada de um aeroporto bem administrado pode fazer
                  pela nossa região?! Muda tudo, gente! Comércio, turismo, economia, tudo melhora!
                  Ou seja: você nem precisa voar de avião para ter sua vida transformada. Fora que,
                  com mais aeroportos, é mais gente voando.
                </p>
                <p style="margin-left: 20px">
                  - Infraero 50 anos. Unir o país e ser uma ponte para o futuro: essa é a nossa
                  missão.
                </p>
              </div>

              <div v-if="campaign.id === 'trabalho-analogo-a-escravidao'">
                <p>
                  Pessoal, agora eu quero falar sobre um assunto muito sério e que precisa da
                  atenção de todo mundo que está nos ouvindo.
                </p>
                <p>
                  Nos primeiros meses de 2023, mais de 1.200 trabalhadores e trabalhadoras foram
                  resgatados em condições degradantes de trabalho, com jornadas exaustivas e, em
                  alguns casos, até sofrendo violência física.
                </p>

                <p>
                  Isso tem nome: é trabalho análogo à escravidão. E o resgate dessas pessoas
                  funcionou com o trabalho do governo federal intensificando a fiscalização. Também
                  funcionou por outro fator muito importante: o aumento das denúncias em todo o
                  país.
                </p>
                <p>
                  Então, se você tiver qualquer suspeita de pessoas trabalhando em condições
                  degradantes, em jornadas exaustivas, sem documentos, sem poder sair ou com
                  violência física, denuncie. Disque 100. Sua ação é muito importante nesse momento
                  para acabar com o trabalho análogo à escravidão.
                </p>
                <p>Vamos juntos lutar por um trabalho digno e decente.</p>
              </div>

              <div v-if="campaign.id === 'acoes-e-programas-do-mec-hospitais-universitarios'">
                <b>
                  Locutor/a da rádio fala sobre a inauguração formal dos blocos B e C do Hospital de
                  Clínicas de Porto Alegre:
                </b>
                <div class="ml-2 mt-2">
                  <p>
                    – Olha só, gente: para melhor atender a população, o Governo Federal, por meio
                    do Ministério da Educação, investiu 555 milhões de reais em infraestrutura,
                    formação e qualificação profissional no Hospital de Clínicas de Porto Alegre,
                    que oferece diversos serviços e especialidades. E, agora, aumentou muuuuuuito a
                    capacidade de atendimento: 500 mil consultas e 45 mil cirurgias por ano! Uau!
                  </p>

                  <p>
                    – E o Hospital de Clínicas de Porto Alegre é um hospital público e
                    universitário, que apoia atividades de 17 cursos da UFRGS e também possui
                    programas próprios de ensino. É educação para reconstruir o país! Um sucesso!
                  </p>

                  <p>
                    – Acompanhe os investimentos em educação no gov.br/mec. Ministério da Educação.
                    Brasil, União e Reconstrução. Governo Federal.
                  </p>
                </div>
              </div>

              <div v-if="campaign.id === 'acoes-de-oportunidade-agenda-oficial-gov-federal'">
                <b> Locução: </b>
                <div class="ml-2 mt-2">
                  <p>
                    E agora pessoal, estou aqui para falar de uma iniciativa muito interessante: a
                    CARAVANA FEDERATIVA está chegando à Bahia! Uma grande oportunidade para
                    prefeitos e secretários municipais receberem atendimento rápido e exclusivo de
                    todos os ministérios e outros órgãos do governo federal.
                  </p>
                  <p>
                    Serão, ao todo, 34 ministérios participando das atividades, junto com entidades
                    como o Fundo Nacional de Desenvolvimento da Educação e a presença dos bancos
                    públicos: BNDES, Banco do Brasil, Caixa Econômica Federal, Banco do Nordeste e
                    Banco Central. Tudo para auxiliar as prefeituras a resolverem eventuais entraves
                    e para os municípios ampliarem a participação em programas do governo, como o
                    Bolsa Família e o Minha Casa Minha Vida.
                  </p>
                  <p>
                    Além do atendimento, também serão realizados painéis e oficinas. Será nos dias
                    24 e 25 de agosto, em Salvador!
                  </p>
                  <p>É a Bahia e o Brasil no rumo certo!</p>
                </div>
              </div>

              <div v-if="campaign.id === '2023-11-regional-ne'">
                <section>
                  <div>
                    <hr class="my-4" />
                    <b> SECOM</b>
                    <br />
                    <b> REGIONAL BAHIA </b>
                  </div>
                  <div class="ml-4 mt-4">
                    <p>
                      <b>Comunicador, tom pra cima, otimista:</b>
                    </p>
                    <p>— Aê, meu povo! Vocês já sabem por que a vida na Bahia tá melhorando?</p>
                    <p>
                      A pobreza JÁ BAI-XOU! Mais de 2 milhões e trezentas mil famílias saíram da
                      linha da pobreza!
                    </p>
                    <p>
                      O preço dos medicamentos do Farmácia Popular também BAI-XOU: até 90% de
                      desconto! E pra quem recebe o Bolsa Família, agora é de graça!
                    </p>
                    <p>E a dívida em atraso? Com o Desenrola Brasil, JÁ BAIXOU!</p>
                    <p>Salário-mínimo: esse JÁ-SU-BIU! E voltou a ter aumento real!</p>
                    <p>Minha Casa Minha Vida: JÁ-SU-BIU e beneficiou 1.550 famílias.</p>
                    <p>
                      Merenda escolar: JÁ-SU-BIU! Com mais recursos, beneficia 3 milhões de alunos.
                    </p>
                    <p>
                      E o desenvolvimento das cidades? Já SU-BIU com o Novo PAC, o maior programa de
                      investimento do Brasil!
                    </p>
                    <p>
                      Eu não tô falando? E, pouco a pouco, a Bahia e o Brasil seguem caminhando pro
                      Rumo Certo!
                    </p>
                    <b>Brasil. União e Reconstrução. Governo Federal.</b>
                  </div>
                </section>
                <section>
                  <div>
                    <hr class="my-4" />
                    <b> SECOM</b>
                    <br />
                    <b> REGIONAL CEARÁ </b>
                  </div>
                  <div class="ml-4 mt-4">
                    <p>
                      <b>Comunicador, tom pra cima, otimista:</b>
                    </p>
                    <p>— Aê, meu povo! Vocês já sabem por que a vida no Ceará tá melhorando?</p>
                    <p>
                      A pobreza JÁ BAI-XOU! 1 milhão e trezentas mil famílias saíram da linha da
                      pobreza!
                    </p>
                    <p>
                      O preço dos medicamentos do Farmácia Popular também BAI-XOU: até 90% de
                      desconto! E pra quem recebe o Bolsa Família, agora é de graça!
                    </p>
                    <p>E a dívida em atraso? Com o Desenrola Brasil, JÁ BAIXOU!</p>
                    <p>Salário-mínimo: esse JÁ-SU-BIU! E voltou a ter aumento real!</p>
                    <p>Minha Casa Minha Vida: JÁ-SU-BIU e beneficiou 880 famílias.</p>
                    <p>
                      Merenda escolar: JÁ-SU-BIU! Com mais recursos, beneficia 1 milhão e novecentas
                      mil alunos.
                    </p>
                    <p>
                      E o desenvolvimento das cidades? Já SU-BIU com o Novo PAC, o maior programa de
                      investimento do Brasil!
                    </p>
                    <p>
                      Eu não tô falando? E, pouco a pouco, o Ceará e o Brasil seguem caminhando pro
                      Rumo Certo!
                    </p>
                    <b>Brasil. União e Reconstrução. Governo Federal.</b>
                  </div>
                </section>
                <section>
                  <div>
                    <hr class="my-4" />
                    <b> SECOM</b>
                    <br />
                    <b> REGIONAL PERNAMBUCO </b>
                  </div>
                  <div class="ml-4 mt-4">
                    <p>
                      <b>Comunicador, tom pra cima, otimista:</b>
                    </p>
                    <p>
                      — Aê, meu povo! Vocês já sabem por que a vida em Pernambuco tá melhorando?
                    </p>
                    <p>
                      A pobreza JÁ BAI-XOU! Mais de 1 milhão e meio de famílias saíram da linha da
                      pobreza!
                    </p>
                    <p>
                      O preço dos medicamentos do Farmácia Popular também BAI-XOU: até 90% de
                      desconto! E pra quem recebe o Bolsa Família, agora é de graça!
                    </p>
                    <p>E a dívida em atraso? Com o Desenrola Brasil, JÁ BAIXOU!</p>
                    <p>Salário-mínimo: esse JÁ-SU-BIU! E voltou a ter aumento real!</p>
                    <p>Minha Casa Minha Vida: JÁ-SU-BIU e beneficiou mil famílias.</p>
                    <p>
                      Merenda escolar: JÁ-SU-BIU! Com mais recursos, beneficia 1 milhão e setecentas
                      mil alunos.
                    </p>
                    <p>
                      E o desenvolvimento das cidades? Já SU-BIU com o Novo PAC, o maior programa de
                      investimento do Brasil!
                    </p>
                    <p>
                      Eu não tô falando? E, pouco a pouco, Pernambuco e o Brasil seguem caminhando
                      pro Rumo Certo!
                    </p>
                    <b>Brasil. União e Reconstrução. Governo Federal.</b>
                  </div>
                </section>
              </div>

              <div v-if="campaign.id === '02-2024-enfrentamento-a-gripe-aviaria-acoes-ambientais'">
                <section>
                  <div>
                    <hr class="my-4" />
                    <b> Roteiro - Texto 1</b>
                    <br />
                    <b> Testemunhal Rádio - 60” </b>
                  </div>
                  <div class="ml-4 mt-4">
                    <p>Pessoal, agora vamos falar de um tema importante, que é gripe aviária.</p>
                    <p>
                      Estamos em pleno verão e sabemos que muita gente adora aproveitar a praia
                      nessa época, né?
                    </p>
                    <p>
                      E sabe quem também adora curtir nossas praias? As aves migratórias, que
                      atravessam o continente com destino ao nosso litoral.
                    </p>
                    <p>
                      Só que algumas delas podem estar com a gripe aviária, que já atingiu até
                      alguns mamíferos marinhos.
                    </p>
                    <p>
                      Desde o ano passado, quando foram registrados os primeiros focos entre animais
                      silvestres nas nossas praias, o Governo Federal tem monitorado a situação para
                      cuidar da nossa natureza e manter segura a produção de aves.
                    </p>
                    <p>
                      Se estiver curtindo a praia e encontrar animais silvestres doentes ou mortos,
                      é só não se aproximar e respeitar o espaço deles. Informe também o Serviço
                      Veterinário Oficial do estado.
                    </p>
                    <p>Para saber mais, visite o site gov.br/gripeaviaria</p>
                    <p>
                      Bora proteger o Brasil da gripe aviária, porque CUIDAR É DA NOSSA NATUREZA.
                    </p>
                  </div>
                </section>
                <section>
                  <div>
                    <hr class="my-4" />
                    <b> Roteiro - Texto 2</b>
                    <br />
                    <b> Testemunhal Rádio - 60” </b>
                  </div>
                  <div class="ml-4 mt-4">
                    <p>
                      Pessoal, já falamos sobre este assunto aqui antes, mas é sempre bom reforçar a
                      mensagem, para que todos fiquem bem informados.
                    </p>
                    <p>Vamos falar de um tema importante, que é a gripe aviária.</p>
                    <p>
                      Estamos em pleno verão e sabemos que muita gente adora aproveitar a praia
                      nessa época, né?
                    </p>
                    <p>
                      E sabe quem também adora curtir nossas praias? As aves migratórias, que
                      atravessam o continente com destino ao nosso litoral. Só que algumas delas
                      podem estar com a gripe aviária, que já atingiu até alguns mamíferos marinhos.
                    </p>
                    <p>
                      Desde o ano passado, quando foram registrados os primeiros focos entre animais
                      silvestres nas nossas praias, o Governo Federal tem monitorado a situação para
                      cuidar da nossa natureza e manter segura a produção de aves.
                    </p>
                    <p>
                      Se estiver curtindo a praia e encontrar animais silvestres doentes ou mortos,
                      é só não se aproximar e respeitar o espaço deles. Informe também o Serviço
                      Veterinário Oficial do estado.
                    </p>
                    <p>Para saber mais, visite o site gov.br/gripeaviaria</p>
                    <p>
                      Bora proteger o Brasil da gripe aviária, porque CUIDAR É DA NOSSA NATUREZA.
                    </p>
                  </div>
                </section>
              </div>

              <div v-if="campaign.id === '04-2024-minha-casa-minha-vida-15-anos'">
                <section>
                  <div>
                    <b> Locutor:</b>
                  </div>
                  <div class="ml-4 mt-4">
                    <p>Gente, vocês sabem quem está comemorando 15 anos de vida?</p>
                    <p>
                      O Minha Casa, Minha Vida. Antes dele, milhares de brasileiros e brasileiras
                      queriam ter a casa própria e não conseguiam. Então ele permitiu que muitas
                      famílias vivessem esse sonho.
                    </p>
                    <p>
                      Graças ao Minha Casa, Minha Vida, já são 7,7 milhões de moradias contratadas.
                      E não vai parar! Até 2026, serão contratadas mais dois milhões de novas
                      moradias.
                    </p>
                    <p>
                      É uma ajuda e tanto para quem precisa sair do aluguel. Essas entregas garantem
                      não só a segurança de um lar, como também desenvolvem a economia e nos fazem
                      acreditar no futuro. De tijolo em tijolo, o Minha Casa, Minha Vida ajudou e
                      vai continuar ajudando os brasileiros e as brasileiras a terem a chave da casa
                      própria. Isso é crescimento, é desenvolvimento.
                    </p>
                    <p>
                      15 anos do Minha Casa, Minha Vida, realizando sonhos e construindo o futuro.
                    </p>
                    <p>
                      <b>Ministério das Cidades.</b>
                      <br />
                      <b>Brasil. União e Reconstrução. Governo Federal.</b>
                    </p>
                  </div>
                </section>
              </div>

              <div
                v-if="
                  campaign.id ===
                  '08-2024-salao-do-turismo-e-feirao-do-turismo-2024-conheca-o-brasil'
                "
              >
                <section>
                  <div>
                    <b> Locutor:</b>
                  </div>
                  <div class="ml-4 mt-4">
                    <p>
                      Ei, você aí de casa! Está pensando em fazer uma viagem, tirar férias ou
                      conhecer mais sobre a cultura do nosso Brasilzão? Então, este recado é para
                      você! Está chegando o Salão do Turismo, uma iniciativa do Governo Federal, por
                      meio do Ministério do Turismo, para que você possa viver de perto as
                      maravilhas de cada região do nosso lindo país.
                    </p>
                    <p>
                      No Salão do Turismo, você vai saborear as delícias culinárias do Brasil,
                      curtir shows ao vivo de diferentes regiões, conhecer um pouco mais da nossa
                      cultura, aproveitar as diversas oportunidades de negócios e, claro, planejar a
                      viagem dos seus sonhos com condições mais que especiais.
                    </p>
                    <p>
                      O evento acontece de 8 a 11 de agosto, no Riocentro. Não vai perder, hein?
                      Para saber mais, acesse: salao.turismo.gov.br. Salão do Turismo: conheça o
                      Brasil, te vejo lá!
                    </p>
                    <p>
                      <b>Ministério do Turismo</b>
                      <br />
                      <b>Governo Federal</b>
                    </p>
                  </div>
                </section>
              </div>

              <div v-if="campaign.id === '01-2025-prestacao-de-contas-rio-grande-do-sul'">
                <section>
                  <div>
                    <b> Locutor:</b>
                  </div>
                  <div class="ml-4 mt-4">
                    <p>Pois é, pessoal!</p>
                    <p>
                      2024 foi um ano de muita dor para os gaúchos. Mas, nos momentos mais difíceis,
                      a gente descobre com quem pode contar. Desde o início das enchentes, o Governo
                      Federal já disponibilizou mais de R$ 100 bilhões para a reconstrução do Rio
                      Grande do Sul. Vou repetir: mais de R$ 100 bilhões.
                    </p>
                    <p>
                      Para garantir emprego e renda, o governo liberou linhas de crédito que já
                      ajudaram mais de 45 mil empresas a retomarem suas atividades.
                    </p>
                    <p>Os programas de moradia vão beneficiar mais de 23 mil famílias!</p>
                    <p>
                      419 mil famílias já receberam o Auxilio Reconstrução, no valor de cinco mil e
                      cem reais cada uma.
                    </p>
                    <p>Tem também a abertura do aeroporto Salgado Filho dentro do prazo.</p>
                    <p>
                      E a nova ponte sobre o Rio Caí, entregue em tempo recorde, com dois meses de
                      antecedência.
                    </p>
                    <p>Saiba mais em brasil.gov.br/UnidosPeloRS</p>
                    <p>Todo dia, a gente faz um Rio Grande e um Brasil melhor.</p>
                    <p>
                      <b>Brasil. União e Reconstrução.</b>
                      <br />
                      <b>Governo Federal.</b>
                    </p>
                  </div>
                </section>
              </div>

              <div v-if="campaign.id == '03-2025-pdot'">
                <section class="ml-4 mb-12">
                  <p>
                    <strong>APRESENTADOR:</strong>
                  </p>
                  <p>
                    Para tudo o que você está fazendo agora! Eu quero te fazer algumas perguntas que
                    são muito importantes!
                  </p>
                  <p>
                    “Como é a cidade em que você quer viver?” Já parou pra pensar nisso? Você quer
                    bastante comércio perto da sua casa, quer sua cidade com muitas áreas verdes,
                    com mais parques, bem organizada, bem planejada?
                  </p>
                  <p>
                    Então, meu amigo, minha amiga, você precisa participar das reuniões do Plano
                    Diretor de Ordenamento Territorial do DF, o P.D.O.T. Caso você não saiba, a cada
                    10 anos o P.D.O.T precisa ser revisado e atualizado.
                  </p>
                  <p>
                    O P.D.O.T é o documento que faz as regiões crescerem de forma ordenada e de
                    acordo com as necessidades da população. Então não perca essa oportunidade, a
                    sua participação é fundamental!
                  </p>
                  <p>
                    Para participar, basta acessar df.gov.br/pdot2025, escolher os temas do seu
                    interesse ou a sua região e conhecer as propostas.
                  </p>
                  <p>Com o P.D.O.T você constrói um DF melhor para viver.</p>

                  <p>
                    <b> GDF </b>
                  </p>
                </section>
              </div>

              <div v-if="campaign.id == 'credito-2025'">
                <section class="ml-4 mb-12">
                  <p>
                    <strong>LOCUTOR:</strong>
                  </p>
                  <p>
                    Eu tenho um recado especial pra você que rala e que dá o gás para botar as
                    contas em dia, mas teve uma despesa inesperada. Tipo uma emergência médica que
                    falta grana para arcar com os custos, por exemplo
                  </p>
                  <p>Tá vivendo esse momento?</p>
                  <p>
                    Então, acesse caixa.gov.br/credito e conheça o Crédito do Trabalhador, que é o
                    consignado para empregados com carteira assinada e registro no eSocial.
                  </p>
                  <p>
                    A taxa de juros é reduzida e o desconto das parcelas já é no contracheque, o que
                    facilita o controle financeiro.
                  </p>
                  <p>
                    Antes de contratar um empréstimo, fale com a CAIXA, confira as condições,
                    compare as taxas e pegue o crédito que cabe no seu orçamento, ok?
                  </p>
                  <p>
                    E ó, não se esqueça que crédito é para usar com cuidado e responsabilidade!
                    Crédito CAIXA. Vem que é seu!
                  </p>
                  <b> CAIXA. Brasil, União e Reconstrução. </b>
                </section>
              </div>

              <div v-if="campaign.id == '05-2025-pdot'">
                <section class="ml-4 mb-12">
                  <p>
                    <strong>LOCUTOR:</strong>
                  </p>
                  <p>
                    Para, para, para, para! Para tudo o que você está fazendo agora! Vocês lembram
                    que há um tempo nós estávamos aqui falando da revisão do PDOT, Plano Diretor de
                    Ordenamento Territorial?
                  </p>
                  <p>
                    Pois é, desde 2021 foram realizadas mais de 85 audiências públicas. Para quem
                    não sabe, o PDOT é uma construção coletiva, por isso contou com a participação
                    de associações, coletivos, organizações não governamentais e membros das áreas
                    técnicas do GDF e pessoas da sociedade civil, como você.
                  </p>
                  <p>
                    Agora, todo esse processo está chegando na sua etapa final, mas a sua
                    participação ainda é muito importante. Por isso, acesse df.gov.br/pdot2025,
                    escolha os temas do seu interesse ou a sua região e conheça as propostas.
                  </p>
                  <p>
                    A sua opinião é muito importante. Você tem até o dia 28 de junho para dar sua
                    opinião e o GDF quer ouvir você!
                  </p>
                  <p>df.gov.br/pdot2025.</p>
                  <p>Este GDF não para!</p>
                </section>
              </div>

              <div v-if="campaign.id == '08-2025-entregas-2025-tema-viadutos'">
                <section class="ml-4 mb-12">
                  <p>
                    <strong>ROTEIRO - tema: VIADUTOS</strong>
                  </p>
                  <p>
                    Eu hoje quero fazer uma pergunta pro pessoal do Recanto das Emas, de Sobradinho,
                    do Paranoá, do Itapuã, do Sudoeste. Vocês se lembram como era a vida de vocês
                    antes do viaduto que agora tem aí na sua cidade? Vocês se lembram de como era o
                    trânsito antes dessas obras?
                  </p>
                  <p>
                    Puxa na memória. Quanta diferença, não é?! E é assim em várias outras
                    localidades do DF que receberam pequenas ou grandes obras de infraestrutura para
                    melhorar o trânsito.
                  </p>
                  <p>
                    Quem lembra de Taguatinga antes do Túnel?! Mudou muito! Este GDF realizou uma
                    promessa de mais de 40 anos! Concluiu o Complexo Viário Governador Roriz na
                    saída norte. E se a gente parar pra lembrar, este GDF tirou muitas obras do
                    papel que mudaram nosso dia a dia.
                  </p>
                  <p>
                    A concretagem da Estrutural, Boulevard de Taguatinga, terceira saída de Águas
                    Claras, terceira pista de Planaltina e muitas outras!
                  </p>
                  <p>
                    Lembrar de como estava o DF e ver como ele está hoje é perceber o quanto já
                    avançamos.
                  </p>
                  <p>Este GDF vai lá e faz!</p>
                </section>
                <section class="ml-4 mb-12">
                  <p>
                    <strong>ROTERIO - tema: PROGRAMAS SOCIAL</strong>
                  </p>
                  <p>
                    “Gente, não sei se vocês já viram, mas tem um comercial do GDF passando na TV
                    lembrando como as coisas mudaram, aqui no Distrito Federal, nos últimos anos.
                  </p>
                  <p>
                    Antes, chegaram a aumentar o preço das refeições nos Restaurantes Comunitários
                    para três reais. Os programas sociais eram poucos e mal atendiam quem mais
                    precisava...
                  </p>
                  <p>
                    Durante a pandemia, inclusive, milhares de famílias tiveram dificuldades pra
                    comprar comida...
                  </p>
                  <p>
                    Aí, o atual governo mudou tudo: reduziu o preço do almoço nos Restaurantes
                    Comunitários para um real. Passou a servir café da manhã e jantar por cinquenta
                    centavos e criou programas como o Cartão Prato Cheio e o Cartão Gás, que somados
                    aos programas que já existiam passaram a beneficiar oitocentas mil pessoas em
                    todo DF.
                  </p>
                  <p>É... mudou de verdade. E mudou pra melhor, não é mesmo?”</p>
                </section>
              </div>

              <div v-if="campaign.id == '11-2025-balanco-institucional-2025-tema-educacao'">
                <section class="ml-4 mb-12">
                  <p>
                    <strong>LOCUTOR:</strong>
                  </p>
                  <p>Você sabia que este GDF faz mais pela educação?</p>
                  <p>Em sete anos, já são treze escolas construídas em todo o DF.</p>
                  <p>
                    E o GDF contratou mais de doze mil profissionais, sendo que mais de seis mil são
                    professores. Eles ainda tiveram aumento de dezoito por cento e a gratificação
                    foi incorporada ao salário. Eles merecem, não é mesmo?
                  </p>
                  <p>
                    O GDF também criou o Cartão Material Escolar, que beneficia duzentos mil alunos
                    da rede pública. E também ajuda centenas de papelarias que já tinham fechado as
                    portas e que graças ao cartão foram reabertas. Isso sim é aquecer a economia!
                  </p>
                  <p>
                    Este GDF também criou o Cartão Creche e construiu 27 novas creches. E, mais oito
                    estão em construção, pra zerar a fila de espera.
                  </p>
                  <p>
                    E não para por aí, não! O GDF construiu a primeira universidade pública
                    distrital e três novas Escolas Técnicas. E a partir de janeiro, os estudantes da
                    rede pública vão receber uniforme de graça.
                  </p>
                  <p>Porque este GDF vai lá e faz.</p>
                </section>
              </div>

              <div v-if="campaign.id == '11-2025-balanco-institucional-2025-tema-autodromo'">
                <section class="ml-4 mb-12">
                  <p>
                    <strong>LOCUTOR:</strong>
                  </p>
                  <p>
                    Gente… deixa eu perguntar uma coisa pra quem gosta de velocidade, quem curte
                    eventos, quem adora ver Brasília cheia de vida: vocês lembram como estava o
                    Autódromo Nelson Piquet?
                  </p>
                  <p>
                    Foram DOZE anos fechado e abandonado. Doze anos parado… sem corrida, sem evento,
                    sem nada acontecendo ali.
                  </p>
                  <p>Mas olha como tudo mudou, hein?!</p>
                  <p>
                    Foi este GDF que revitalizou o autódromo. Completamente! Estrutura nova, mais
                    segurança, tudo modernizado… e o espaço voltou com tudo, já recebendo a Stock
                    Car e lotando arquibancadas. A cidade inteira sentiu aquela energia de volta!
                  </p>
                  <p>E o melhor: não é só pra corrida, não.</p>
                  <p>
                    O novo autódromo agora tá pronto pra receber shows, feiras, exposições e várias
                    atividades esportivas e de lazer, como provas de corrida e ciclismo. É mais
                    diversão pra população, mais movimentação na economia, mais empregos e mais
                    turistas chegando no DF.
                  </p>
                  <p>
                    Quando a gente lembra como estava… e vê como tá agora… dá pra perceber a
                    diferença.
                  </p>
                  <p>Porque este GDF foi lá e fez! GDF.</p>
                </section>
              </div>

              <div v-if="campaign.id == '01-2026-motociclista-2026'">
                <section class="ml-4 mb-12">
                  <p>
                    <strong>LOCUTOR:</strong>
                  </p>
                  <p>
                    No Distrito Federal, existem mais 293 mil motos. É muita gente que usa a moto
                    como meio de transporte pra ir pro trabalho, pra passear e como profissão.
                  </p>
                  <p>
                    Mas muitos motociclistas não chegam em casa ao fim do dia. Só no ano passado,
                    mais de 100 motociclistas morreram nas vias do DF. Pessoas que tiveram as suas
                    vidas interrompidas muitas vezes por algum vacilo que podia ter sido evitado.
                  </p>
                  <p>
                    E o trânsito não perdoa quem vacila. Por isso, motociclista, pilote com cuidado
                    e atenção. Use sempre o capacete, respeite os limites de velocidade, mantenha
                    uma distância segura dos outros veículos e não beba se for pilotar.
                  </p>
                  <p>
                    Lembre-se: a pressa não vale a sua vida. Detran-DF e GDF. No trânsito, enxergar
                    o outro é salvar vidas.
                  </p>
                </section>
              </div>

              <div v-if="campaign.id == '03-2026-balanco-institucional-2026-tema-nefrologia'">
                <section class="ml-4 mb-12">
                  <p>
                    <strong>LOCUTOR:</strong>
                  </p>
                  <p>
                    Olha aí, gente! Tem uma notícia maravilhosa pra nossa rede de saúde pública e
                    principalmente pra quem depende de hemodiálise aqui no Distrito Federal.
                  </p>
                  <p>
                    Você sabia que este GDF trocou os equipamentos avançados de filtragem do
                    sangue?! Sim, os novos equipamentos estão garantindo o atendimento mais rápido
                    para quem precisa.
                  </p>
                  <p>
                    E o resultado já está sendo sentido pela população. Os números de atendimento
                    saltaram de setecentos e setenta e quatro para dois mil e duzentos e vinte
                    atendimentos por mês! Incrível, não é?!
                  </p>
                  <p>
                    Isso é inédito aqui no DF! Foram décadas com os mesmos equipamentos até vir este
                    GDF e renovar tudo. E não foi só isso: as salas de hemodiálise no Hospital de
                    Taguatinga e no Hospital do Gama foram reformadas.
                  </p>
                  <p>
                    Hoje, quem depende de hemodiálise para viver, espera menos e tem mais qualidade
                    de vida. E não é só qualidade de vida, né, pessoal?
                  </p>
                  <p>É dignidade também! Porque este GDF vai lá e faz!</p>
                </section>
              </div>

              <div v-if="campaign.id == '04-2026-agronegocio-2026'">
                <section class="ml-4 mb-12">
                  <p>
                    <strong>LOCUTOR:</strong>
                  </p>
                  <p>
                    Com o Custeio Agrícola e Pecuário do Banco da Amazônia e do Governo do Brasil, o
                    produtor tem o apoio que precisa no tempo certo da sua produção.
                  </p>
                  <p>
                    Pode adquirir insumos, sementes, ração, maquinário e muito mais. As taxas e os
                    prazos são os melhores do mercado: a partir de meio por cento ao ano e até três
                    anos para pagar.
                  </p>
                  <p>
                    E quer saber o melhor de tudo? Se você pagar as parcelas sempre em dia, ainda
                    tem bônus de até quarenta por cento!
                  </p>
                  <p>
                    Tá esperando o quê? Conte com essa força em todos os estágios da sua produção
                    agrícola ou pecuária: fale com o seu gerente em uma de nossas agências ou acesse
                    bancoamazonia.com.br/custeio.
                  </p>
                  <p>Banco da Amazônia. Sonhar. Mover. Impactar.</p>
                  <p>Governo do Brasil.</p>
                </section>
              </div>

              <div
                v-if="
                  campaign.id == '08-2026-prevencao-aos-incendios-florestais' ||
                  campaign.id == '09-2026-prevencao-aos-incendios-florestais-reforco'
                "
              >
                <section class="ml-4 mb-12">
                  <p>
                    <strong>LOCUTOR:</strong>
                  </p>
                  <p>
                    Agora um assunto bem sério. A seca tá aí e os riscos de incêndios florestais
                    aumentam muito nessa época. Sabe o que isso significa na prática? Milhares de
                    hectares de plantações queimados. Milhares de árvores queimadas. Milhares de
                    animais mortos. Milhões de litros de água usados no combate.
                  </p>
                  <p>
                    Em 2022, um incêndio no Parque Nacional de Brasília consumiu o equivalente a 14
                    mil campos de futebol. E, em outro incêndio, em 2019, Buritis com mais de 300
                    anos viraram cinzas em minutos.
                  </p>
                  <p>
                    O mais assustador é que 95% dos incêndios florestais começam com uma ação
                    humana. Por isso, todo cuidado é pouco.
                  </p>
                  <p>
                    Não use fogo para queimar lixo ou entulho, nem para limpar terrenos. Se fizer
                    fogueiras, certifique-se de que elas sejam totalmente apagadas. Queimar lixo e
                    restos de poda é crime ambiental.
                  </p>
                  <p>Ligue 193 e denuncie.</p>
                  <p>Governo do Distrito Federal.</p>
                </section>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-container>
        <v-row id="censure" class="text-center">
          <v-col cols="12">
            <h2 class="text-h4 primary--text text--darken-3 font-weight-light font-italic py-8">
              CENSURA
            </h2>
          </v-col>
        </v-row>
        <v-row class="pa-4">
          <v-col cols="12">
            <v-card v-if="campaign">
              <v-card-title>
                {{ campaign.name }}
              </v-card-title>
              <v-card-subtitle>{{ campaign.client }}</v-card-subtitle>
              <v-card-text class="">
                <v-row>
                  <v-col cols="12">
                    <strong>Qtde.:</strong>
                    <span>
                      {{ campaign.censuresData ? campaign.censuresData.length : 0 }}
                    </span>
                    <span class="mx-2"> | </span>
                    <strong>P.i.:</strong>
                    <span>
                      {{
                        campaign.piCamp
                          ? campaign.piCamp
                          : campaign.censuresData
                          ? campaign.censuresData[0].pi
                          : ""
                      }}
                    </span>
                    <span class="mx-2"> | </span>
                    <strong>Período:</strong>
                    <span>
                      {{
                        campaign.timeFrame
                          ? campaign.timeFrame
                          : campaign.censuresData
                          ? campaign.censuresData[0].periodo
                          : ""
                      }}
                    </span>
                    <span class="mx-2"> | </span>
                    <strong>Tipo/Duração:</strong>
                    <span>
                      {{
                        campaign.type
                          ? campaign.type
                          : campaign.censuresData
                          ? campaign.censuresData[0].tipo
                          : ""
                      }}/{{
                        campaign.format
                          ? campaign.format
                          : campaign.censuresData
                          ? campaign.censuresData[0].formato
                          : ""
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="campaign.censuresData"
                  :search="search"
                  sort-by="idSecom"
                  show-expand
                  :expanded.sync="expanded"
                  :footer-props="{
                    'items-per-page-all-text': 'Todas',
                    'items-per-page-text': 'Censuras por página:',
                    'items-per-page-options': [15, 50, 100, -1],
                  }"
                  class="elevation-1"
                  item-key="idApp"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>CENSURAS</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-toolbar>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pb-8 pt-6 grey--text text--darken-1">
                      <strong>Programa:</strong> {{ item.programa }}
                      <span class="mx-2"> | </span>
                      <strong>Apresentador:</strong> {{ item.apresentador }}
                      <span class="mx-2"> | </span>
                      <strong>Hor. Início:</strong> {{ item.inicio }} <span class="mx-2"> | </span>
                      <strong>Hor. Fim:</strong>
                      {{ item.fim }}
                    </td>
                  </template>
                  <template v-slot:[`item.audio`]="{ item }">
                    <div v-if="item.audioData">
                      <v-icon small color="primary" @click="openAudioPlayer(item)">
                        mdi-play-circle
                      </v-icon>
                    </div>
                  </template>
                  <template v-slot:no-data>
                    <p class="mt-4">
                      Nenhuma censura encontrada! Os registros cadastrados aparecerão aqui.
                    </p>
                  </template>
                  <template v-slot:no-results>
                    <p class="mt-4">Nenhuma resultado encontrado para busca: {{ search }}</p>
                  </template>
                </v-data-table>
              </v-card-text>

              <v-card-actions class="pb-4 pr-4">
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="expandAll()"
                  >{{ expanded.length ? "Fechar" : "Expandir" }} Todos</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <div class="grey lighten-2 mt-12" id="footer">
        <v-container>
          <v-row id="censure" class="text-center my-0">
            <v-col cols="12">
              <!-- <p>footer</p> -->
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <!-- bottom audio player Dialog -->
    <v-bottom-sheet inset v-model="playerDialog" @click:outside="closeAudioPlayer()">
      <v-card tile>
        <v-progress-linear :value="100" class="my-0" height="3"></v-progress-linear>

        <v-container class="pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" sm="4">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ audioPlayerData.veiculo }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ audioPlayerData.apresentador }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="caption">
                      {{ audioPlayerData.programa }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="6" class="mt-3 d-flex justify-center">
              <v-btn
                class="mr-2 mt-2 elevation-0 fixed-bottom"
                dark
                small
                color="primary"
                @click="playSprite()"
              >
                <v-icon dark small> mdi-play </v-icon>
                Tocar o trecho da Censura
              </v-btn>
              <audio
                v-if="audioPlayerData"
                :src="audioPlayerData.src"
                ref="audioPlayer"
                controls
                style="width: 100%"
              ></audio>
            </v-col>
            <v-col cols="12" sm="2" class="mb-8 mb-sm-2">
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ audioPlayerData.veiculacao }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ audioPlayerData.time }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="caption">
                      {{ audioPlayerData.numInsercao }} |
                      {{ audioPlayerData.numTexto }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { db, onSnapshot, collection, query, where } from "@/firebase/firebase";

export default {
  name: "Campaign",

  components: {
    //
  },

  mounted() {
    if (this.$route.params.id) {
      // this.subscribeListerner();
      this.$store.dispatch("loadCampaignWithOnlyPublishedCensures", this.$route.params.id);
    }
  },

  destroyed() {
    this.unsubscribeListener();
    if (this.campaign) this.$store.dispatch("loadCampaignWithCensuresData", this.campaign.id);
  },

  data() {
    return {
      selectedDate: null,
      headers: [
        {
          text: "Data Veic.",
          sortable: true,
          value: "veiculacao",
        },
        {
          text: "Horário",
          sortable: true,
          value: "audioData.time",
        },
        {
          text: "Agência",
          sortable: true,
          value: "agencia",
        },
        {
          text: "iD Secom",
          sortable: true,
          value: "idSecom",
        },
        {
          text: "Pi Veículo",
          sortable: true,
          value: "piVeiculo",
        },
        {
          text: "Estado",
          sortable: true,
          value: "uf",
        },
        {
          text: "Município",
          sortable: true,
          value: "municipio",
        },
        {
          text: "Veículo",
          sortable: true,
          value: "veiculo",
        },
        {
          text: "Apresentador",
          sortable: true,
          value: "apresentador",
        },
        { text: "Áudio", value: "audio", sortable: false, align: "center" },
      ],
      search: "",
      expanded: [],
      censureList: null,
      internalLoading: null,
      unsubscribeListener: null,
      playerDialog: false,
      audioPlayerData: {},
      selectedAudio: null,
    };
  },

  computed: {
    campaign() {
      return this.$store.getters.getCampaign;
    },
    feedback() {
      return this.$store.getters.getFeedback;
    },
    user() {
      return this.$store.getters.getUser;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    loading() {
      return this.$store.getters.getLoading;
    },
  },

  watch: {
    campaign(v) {
      if (v) {
        this.subscribeListerner();
      }
    },
  },

  methods: {
    expandAll() {
      // console.log(this.expanded.length);
      if (!this.expanded.length) {
        this.expanded = this.campaign.censuresData;
      } else {
        this.expanded = [];
      }
    },
    subscribeListerner() {
      console.log("Subscribe Listener");
      this.internalLoading = true;
      const q = query(
        collection(db, "campaigns", this.$route.params.id, "censuresData"),
        where("status", ">=", 2),
      );
      this.unsubscribeListener = onSnapshot(q, (querySnapshot) => {
        const newCampaign = this.campaign;
        if (newCampaign) newCampaign.censuresData = [];
        querySnapshot.forEach((doc) => {
          const newCensure = {
            id: doc.id,
            ...doc.data(),
          };
          newCensure.veiculacao = newCensure.veiculacao.toDate().toLocaleDateString("pt-BR");
          newCampaign.censuresData.push(newCensure);
        });
        this.$store.dispatch("UpdateVuexCampaign", newCampaign);
      });
    },
    isOdd(num) {
      return num % 2;
    },
    playAudio2(id, src, start) {
      const player = document.getElementById(id);
      player.src = src;
      player.type = "audio/mpeg";
      if (player.paused == true) {
        if (start) player.currentTime = start;
        player.play();
      } else {
        player.pause();
      }
    },
    openAudioPlayer(item) {
      console.log("Open Player Dialog");
      this.selectedAudio = item.audioData;
      this.playerDialog = true;
      this.audioPlayerData.src = item.audioData.audioUrl;
      this.audioPlayerData.veiculo = item.veiculo;
      this.audioPlayerData.apresentador = item.apresentador;
      this.audioPlayerData.programa = item.programa;
      this.audioPlayerData.veiculacao = item.veiculacao;
      this.audioPlayerData.time = item.audioData.time;
      this.audioPlayerData.numTexto = item.numTexto;
      this.audioPlayerData.numInsercao = item.numInsercao;
      console.log(this.player);
    },
    closeAudioPlayer() {
      this.audioPlayerData = {};
      // this.audioPlayerData.src = null;
      this.$refs.audioPlayer.src = null;
      this.selectedAudio = null;
      console.log("closing...");
    },
    playSprite() {
      const player = this.$refs.audioPlayer;
      const initM = this.selectedAudio.cut.inicioMinutos;
      const initS = this.selectedAudio.cut.inicioSegundos;
      const finalM = this.selectedAudio.cut.fimMinutos;
      const finalS = this.selectedAudio.cut.fimSegundos;
      const initialTime = parseInt(initM) * 60 + parseInt(initS);
      let finalTime = parseInt(finalM) * 60 + parseInt(finalS);
      if (finalTime < 1) finalTime = player.duration;
      if (initialTime > finalTime)
        this.audioFeedback = "Tempo inicial do corte está maior que o tempo final...";
      if (player && initialTime <= finalTime) {
        player.currentTime = initialTime;
        this.spriteStatus = true;
        player.play();
        const playInterval = setInterval(() => {
          if (player.currentTime >= finalTime) {
            player.pause();
            clearInterval(playInterval);
            this.spriteStatus = false;
          }
        }, 1000);
      }
    },
    secondsToMinutes(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${("0" + minutes).slice(-2)}:${("0" + seconds).slice(-2)}`;
    },
  },
};
</script>

<style scoped>
.Campaign {
  padding: 0;
}
#footer {
  height: 400px;
}
.push-top-right {
  position: absolute;
  right: 21px;
  top: 21px;
}
.fixed-bottom {
  position: absolute;
  bottom: -3px;
}
</style>
